(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p4-footer-dino"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faunov-footer-dino')) {
  customElements.define('faunov-footer-dino', class extends HTMLElement {
    connectedCallback() {
      this.actor = this.querySelector('.p4-dino__actor');
      this.track = this.querySelector('.p4-dino__track');
      this.face = this.querySelector('.p4-dino__face');
      this.bubble = this.querySelector('.p4-dino__bubble');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.x = 0;
      this.direction = 1;
      this.elapsed = 0;
      this.nextGreeting = 3;
      this.greetingUntil = 0;
      this.greetingStart = 0;
      this.hovered = false;
      this.step = 0;
      this.visible = false;
      this.tick = this.tick.bind(this);
      this.refresh = this.refresh.bind(this);
      this.onEnter = () => {
        this.hovered = true;
        this.greetingStart = this.elapsed;
        this.toggleAttribute('data-greeting', true);
        this.style.setProperty('--dino-frame', (-3 * (this.size || 96)) + 'px');
        this.toggleAttribute('data-blink', !this.motion.matches);
      };
      this.onLeave = () => {
        this.hovered = false;
        this.greetingUntil = Math.max(this.greetingUntil, this.elapsed + .6);
        if (this.motion.matches) {
          this.removeAttribute('data-greeting');
          this.removeAttribute('data-blink');
        }
      };
      this.actor.addEventListener('pointerenter', this.onEnter);
      this.actor.addEventListener('pointerleave', this.onLeave);
      this.motion.addEventListener('change', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      this.resizeObserver = new ResizeObserver(() => {
        this.size = this.actor.offsetWidth;
        this.limit = Math.max(0, this.track.clientWidth - this.size);
        this.x = Math.min(this.x, this.limit);
        this.render();
      });
      this.resizeObserver.observe(this.track);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.refresh();
      });
      this.observer.observe(this);
    }
    refresh() {
      cancelAnimationFrame(this.raf);
      this.last = 0;
      this.removeAttribute('data-greeting');
      this.removeAttribute('data-blink');
      if (this.motion.matches) {
        this.style.setProperty('--dino-frame', '0px');
        return;
      }
      if (this.visible && !document.hidden) this.raf = requestAnimationFrame(this.tick);
    }
    render() {
      this.actor.style.transform = 'translateX(' + Math.round(this.x) + 'px)';
      this.face.style.setProperty('--dino-facing', this.direction);
      const width = this.bubble.offsetWidth;
      const anchor = this.x + (this.size || 96) / 2;
      const left = Math.max(4, Math.min(anchor - width / 2, this.track.clientWidth - width - 4));
      this.bubble.style.setProperty('--bubble-offset', (left - anchor) + 'px');
      const headX = this.x + (this.size || 96) * (this.direction === 1 ? .7 : .3);
      this.bubble.style.setProperty('--bubble-tail', Math.max(14, Math.min(width - 14, headX - left)) + 'px');
    }
    tick(time) {
      const dt = this.last ? Math.min((time - this.last) / 1000, .05) : 0;
      this.last = time;
      this.elapsed += dt;
      if (this.elapsed >= this.nextGreeting) {
        this.greetingUntil = this.elapsed + 3;
        this.greetingStart = this.elapsed;
        this.nextGreeting = this.elapsed + 18;
      }
      const greeting = this.hovered || this.elapsed < this.greetingUntil;
      this.toggleAttribute('data-greeting', greeting);
      this.toggleAttribute('data-blink', greeting && ((this.elapsed - this.greetingStart) % 1.4 < .18));
      if (!greeting) {
        this.x += this.direction * (this.size === 80 ? 13 : 22) * dt;
        if (this.x >= this.limit) { this.x = this.limit; this.direction = -1; }
        if (this.x <= 0) { this.x = 0; this.direction = 1; }
        this.step += dt;
      }
      const frame = greeting ? 3 : Math.floor(this.step / .18) % 4;
      this.style.setProperty('--dino-frame', (-frame * (this.size || 96)) + 'px');
      this.render();
      this.raf = requestAnimationFrame(this.tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.motion?.removeEventListener('change', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
      this.actor?.removeEventListener('pointerenter', this.onEnter);
      this.actor?.removeEventListener('pointerleave', this.onLeave);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p4-site-header"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faunov-scroll-header')) {
    customElements.define('faunov-scroll-header', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.panel = this.querySelector('.p4-scrollHeaderPanel');
        if (!this.panel) return;
        this.last = this.getBoundingClientRect().top;
        this.travel = 0;
        this.direction = 0;
        this.update = () => {
          this.frame = 0;
          const rect = this.getBoundingClientRect();
          const delta = this.last - rect.top;
          this.last = rect.top;
          const direction = Math.sign(delta);
          if (direction && direction !== this.direction) {
            this.travel = 0;
            this.direction = direction;
          }
          this.travel += Math.abs(delta);
          if (rect.top >= 0) {
            this.removeAttribute('data-floating');
            this.removeAttribute('data-visible');
            this.travel = 0;
            return;
          }
          if (!this.hasAttribute('data-floating') && rect.bottom > 0) return;
          if (!this.hasAttribute('data-floating')) {
            this.setAttribute('data-floating', '');
            this.panel.getBoundingClientRect();
          }
          if (this.panel.contains(document.activeElement) || this.querySelector('details[open]')) {
            this.setAttribute('data-visible', '');
          } else if (direction < 0 && this.travel >= 6) {
            this.setAttribute('data-visible', '');
          } else if (direction > 0 && this.travel >= 60) {
            this.removeAttribute('data-visible');
          }
        };
        this.queue = () => {
          if (!this.frame) this.frame = requestAnimationFrame(this.update);
        };
        this.resize = () => {
          const rect = this.getBoundingClientRect();
          this.style.setProperty('--p4-header-left', rect.left + 'px');
          this.style.setProperty('--p4-header-width', rect.width + 'px');
          this.style.height = this.panel.offsetHeight + 'px';
          this.queue();
        };
        this.focus = () => {
          if (this.hasAttribute('data-floating')) this.setAttribute('data-visible', '');
        };
        this.cartUpdate = (event) => {
          event.promise?.then(({ cart, detail }) => {
            const itemCount = cart?.totalQuantity ?? detail?.itemCount;
            if (!Number.isFinite(itemCount)) return;
            document.querySelectorAll('[data-p4-cart-count]').forEach((count) => {
              count.textContent = String(itemCount);
            });
          }).catch(() => {});
        };
        this.observer = new ResizeObserver(this.resize);
        this.observer.observe(this.panel);
        document.addEventListener('scroll', this.queue, { capture: true, passive: true });
        document.addEventListener('shopify:cart:lines-update', this.cartUpdate);
        window.addEventListener('resize', this.resize);
        this.addEventListener('focusin', this.focus);
        this.resize();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        document.removeEventListener('scroll', this.queue, true);
        document.removeEventListener('shopify:cart:lines-update', this.cartUpdate);
        window.removeEventListener('resize', this.resize);
        this.removeEventListener('focusin', this.focus);
      }
    });
  }
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-p4-announcement]').forEach((bar) => {
        if (bar.dataset.announcementReady === 'true') return;
        bar.dataset.announcementReady = 'true';
        const slides = Array.from(bar.querySelectorAll('.p4-offerSlide'));
        let active = 0;
        let timer;
        const show = (index) => {
          active = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === active;
            slide.hidden = !isActive;
            slide.classList.toggle('p4-offerSlideActive', isActive);
          });
        };
        const start = () => {
          clearInterval(timer);
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            timer = setInterval(() => show(active + 1), 2000);
          }
        };
        bar.querySelector('[data-p4-announcement-previous]')?.addEventListener('click', () => {
          show(active - 1);
          start();
        });
        bar.querySelector('[data-p4-announcement-next]')?.addEventListener('click', () => {
          show(active + 1);
          start();
        });
        bar.addEventListener('mouseenter', () => clearInterval(timer));
        bar.addEventListener('mouseleave', start);
        bar.addEventListener('focusin', () => clearInterval(timer));
        bar.addEventListener('focusout', (event) => {
          if (!bar.contains(event.relatedTarget)) start();
        });
        start();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p4-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faunov-wishlist')) {
    customElements.define('faunov-wishlist', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.key = 'faunov-wishlist-v2';
        this.selector = '[data-p4-favorite], [data-faunov-product-favorite]';
        this.dialog = this.querySelector('dialog');
        this.toast = this.querySelector('.fw-toast');
        this.list = this.querySelector('.fw-list');
        if (!this.dialog || this.ready) return;
        this.ready = true;
        this.persistent = true;
        this.items = this.read();
        this.click = (event) => {
          const button = event.target.closest(this.selector);
          if (button) {
            event.preventDefault();
            this.items = this.read();
            const item = this.product(button);
            const index = this.items.findIndex(saved => this.matches(saved, item));
            const added = index < 0;
            if (added) this.items.push(item);
            else this.items.splice(index, 1);
            this.save();
            this.refresh();
            this.notify(item, added);
            return;
          }
          if (event.target.closest('[data-p4-favorites-link], [data-faunov-favorites-link], [data-fw-open]')) {
            event.preventDefault();
            this.dismiss();
            this.refresh();
            this.opener = event.target.closest('button, a');
            this.opener?.closest('details')?.removeAttribute('open');
            if (!this.dialog.open) this.dialog.showModal();
          }
        };
        this.storage = (event) => {
          if (event.key === this.key || event.key === null) {
            this.items = this.read();
            this.refresh();
          }
        };
        this.sync = () => this.refresh();
        this.visible = () => {
          if (document.visibilityState === 'visible') this.sync();
        };
        this.close = () => this.dialog.close();
        this.closed = () => {
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        };
        this.hideToast = () => this.dismiss();
        this.querySelector('[data-fw-close]').addEventListener('click', this.close);
        this.querySelector('[data-fw-dismiss]').addEventListener('click', this.hideToast);
        this.dialog.addEventListener('close', this.closed);
        this.backdrop = (event) => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
        };
        this.dialog.addEventListener('click', this.backdrop);
        this.pauseToast = () => clearTimeout(this.timer);
        this.resumeToast = () => {
          clearTimeout(this.timer);
          if (!this.toast.matches(':hover') && !this.toast.contains(document.activeElement)) this.timer = setTimeout(() => this.dismiss(), 6500);
        };
        this.toast.addEventListener('pointerenter', this.pauseToast);
        this.toast.addEventListener('pointerleave', this.resumeToast);
        this.toast.addEventListener('focusin', this.pauseToast);
        this.toast.addEventListener('focusout', this.resumeToast);
        document.addEventListener('click', this.click);
        window.addEventListener('storage', this.storage);
        window.addEventListener('focus', this.sync);
        window.addEventListener('pageshow', this.sync);
        document.addEventListener('visibilitychange', this.visible);
        this.observer = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(this.selector) || node.querySelector?.(this.selector))))) this.refresh();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.refresh();
      }
      read() {
        if (this.sessionOnly) return this.items || [];
        try {
          const raw = localStorage.getItem(this.key);
          if (raw !== null) {
            const items = JSON.parse(raw);
            return Array.isArray(items) ? items.filter(x => x && typeof x.title === 'string' && typeof x.id === 'string').map(x => ({ id: x.id, title: x.title, url: this.safeURL(x.url), image: this.safeURL(x.image, true) })) : [];
          }
          const legacy = JSON.parse(localStorage.getItem('faunov-favorites') || '[]');
          return Array.isArray(legacy) ? [...new Set(legacy.filter(x => typeof x === 'string'))].map(title => ({ id: 'legacy:' + title, title, url: '', image: '' })) : [];
        } catch (_) {
          this.persistent = false;
          return this.items || [];
        }
      }
      safeURL(value, image = false) {
        if (typeof value !== 'string' || !value) return '';
        try {
          const url = new URL(value, location.origin);
          if (!['https:', 'http:'].includes(url.protocol)) return '';
          if (!image && url.origin !== location.origin) return '';
          if (image && url.origin !== location.origin && url.hostname !== 'cdn.shopify.com') return '';
          return url.href;
        } catch (_) { return ''; }
      }
      product(button) {
        const title = button.dataset.p4Favorite || button.dataset.faunovProductFavorite;
        const card = button.closest('[data-p4-product-url]');
        const image = card?.querySelector('.p4-productMedia img');
        return {
          id: button.dataset.favoriteId || 'legacy:' + title,
          title,
          url: this.safeURL(button.dataset.favoriteUrl || card?.dataset.p4ProductUrl),
          image: this.safeURL(button.dataset.favoriteImage || image?.currentSrc || image?.src, true)
        };
      }
      matches(saved, item) {
        return saved.id === item.id || (saved.id.startsWith('legacy:') && saved.title === item.title);
      }
      save() {
        try {
          localStorage.setItem(this.key, JSON.stringify(this.items));
          this.persistent = true;
          this.sessionOnly = false;
        } catch (_) {
          this.persistent = false;
          this.sessionOnly = true;
        }
      }
      refresh() {
        this.items = this.read();
        document.querySelectorAll(this.selector).forEach(button => {
          const item = this.product(button);
          const index = this.items.findIndex(saved => this.matches(saved, item));
          if (index >= 0 && JSON.stringify(this.items[index]) !== JSON.stringify(item)) {
            this.items[index] = item;
          }
          button.classList.toggle('p4-favoriteActive', index >= 0);
          button.classList.toggle('is-active', index >= 0);
          button.setAttribute('aria-pressed', String(index >= 0));
          const label = button.dataset[index >= 0 ? 'removeLabel' : 'addLabel'];
          if (label) button.setAttribute('aria-label', label);
        });
        document.querySelectorAll('[data-p4-favorites-link], [data-faunov-favorites-link]').forEach(button => {
          let badge = button.querySelector('[data-fw-count]');
          if (!badge) {
            badge = document.createElement('b');
            badge.className = 'p4-favoriteCount';
            badge.setAttribute('data-fw-count', '');
            badge.setAttribute('aria-hidden', 'true');
            button.append(badge);
          }
          const count = this.items.length;
          badge.textContent = String(count);
          badge.hidden = count === 0;
          if (!button.dataset.fwBaseLabel) button.dataset.fwBaseLabel = button.getAttribute('aria-label') || this.querySelector('#fw-title').textContent.trim();
          button.setAttribute('aria-label', button.dataset.fwBaseLabel + (count ? ' (' + count + ')' : ''));
        });
        this.querySelector('.fw-count').textContent = '(' + this.items.length + ')';
        this.querySelector('.fw-note').textContent = this.persistent ? this.dataset.saved : this.dataset.session;
        this.querySelector('.fw-empty').hidden = this.items.length > 0;
        this.list.replaceChildren();
        this.items.forEach(item => {
          const row = document.createElement('li');
          row.className = 'fw-item';
          const img = document.createElement(item.image ? 'img' : 'span');
          img.className = 'fw-thumb';
          if (item.image) {
            img.src = item.image; img.alt = ''; img.loading = 'lazy';
            img.addEventListener('error', () => { img.removeAttribute('src'); img.style.visibility = 'hidden'; }, { once: true });
          } else img.setAttribute('aria-hidden', 'true');
          const link = document.createElement('a');
          link.href = item.url || this.dataset.search + '?type=product&q=' + encodeURIComponent(item.title);
          link.textContent = item.title;
          const detail = document.createElement('small');
          detail.textContent = item.url ? this.dataset.view : this.dataset.find;
          link.append(detail);
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'fw-close'; remove.textContent = '×';
          remove.setAttribute('aria-label', this.dataset.remove + ': ' + item.title);
          remove.addEventListener('click', () => {
            this.items = this.read();
            const index = this.items.findIndex(saved => saved.id === item.id);
            this.items = this.items.filter(saved => saved.id !== item.id);
            this.save(); this.refresh();
            const buttons = this.list.querySelectorAll('button');
            (buttons[Math.min(index, buttons.length - 1)] || this.querySelector('[data-fw-close]')).focus();
          });
          row.append(img, link, remove); this.list.append(row);
        });
      }
      notify(item, added) {
        const image = this.querySelector('.fw-toastImage');
        image.hidden = !item.image;
        if (item.image) {
          image.src = item.image;
          image.onerror = () => { image.hidden = true; };
        }
        this.querySelector('.fw-message').textContent = added ? this.dataset.added : this.dataset.removed;
        this.querySelector('.fw-toastNote').textContent = this.persistent ? this.dataset.saved : this.dataset.session;
        this.toast.showPopover();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.dismiss(), 6500);
      }
      dismiss() {
        clearTimeout(this.timer);
        if (this.toast?.matches(':popover-open')) this.toast.hidePopover();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('click', this.click);
        window.removeEventListener('storage', this.storage);
        window.removeEventListener('focus', this.sync);
        window.removeEventListener('pageshow', this.sync);
        document.removeEventListener('visibilitychange', this.visible);
        this.querySelector('[data-fw-close]')?.removeEventListener('click', this.close);
        this.querySelector('[data-fw-dismiss]')?.removeEventListener('click', this.hideToast);
        this.dialog?.removeEventListener('close', this.closed);
        this.dialog?.removeEventListener('click', this.backdrop);
        this.toast?.removeEventListener('pointerenter', this.pauseToast);
        this.toast?.removeEventListener('pointerleave', this.resumeToast);
        this.toast?.removeEventListener('focusin', this.pauseToast);
        this.toast?.removeEventListener('focusout', this.resumeToast);
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
